import { InjectionKey } from 'vue';
import { Order } from '@/fairplayer/domain/fan/order/Order';
import { ClubSlug } from '@/fairplayer/domain/club/ClubSlug';

export const orderRepositoryKey: InjectionKey<OrderRepository> = Symbol();

export interface OrderRepository {
  listFor(clubSlug: ClubSlug): Promise<Order[]>;
}
